@if (mode === 'renderer') {
  <div
    class="best-sellers-dc-canvas"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft
    }"
  >
    <div class="best-sellers-header">
      @if (element.fields.title) {
        <h3>{{ element.fields.title | translate }}</h3>
      }
      <div
        class="best-sellers-toggle"
        role="group"
        aria-label="{{ 'SORT_BY' | translate }}"
        [style.--dc-toggle-radius.px]="element.fields.toggleBorderRadius"
      >
        <button
          type="button"
          class="dc-toggle-btn"
          [class.dc-toggle-btn--active]="rankBy === 'qty'"
          [attr.aria-pressed]="rankBy === 'qty'"
          [style.--dc-toggle-bg]="rankBy === 'qty' ? element.fields.toggleActiveBackground : element.fields.toggleInactiveBackground"
          [style.--dc-toggle-color]="rankBy === 'qty' ? element.fields.toggleActiveColor : element.fields.toggleInactiveColor"
          (click)="setRankBy('qty')"
        >
          {{ 'QTY' | translate }}
        </button>
        <button
          type="button"
          class="dc-toggle-btn"
          [class.dc-toggle-btn--active]="rankBy === 'value'"
          [attr.aria-pressed]="rankBy === 'value'"
          [style.--dc-toggle-bg]="rankBy === 'value' ? element.fields.toggleActiveBackground : element.fields.toggleInactiveBackground"
          [style.--dc-toggle-color]="rankBy === 'value' ? element.fields.toggleActiveColor : element.fields.toggleInactiveColor"
          (click)="setRankBy('value')"
        >
          {{ 'VALUE' | translate }}
        </button>
      </div>
    </div>

    @if (loading) {
      <div class="text-center p-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden" translate>LOADING</span>
        </div>
      </div>
    } @else if (carouselItems.length === 0) {
      <p class="text-muted" translate>NO_DATA</p>
    } @else if (carouselAlive) {
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let item of carouselItems">
          <ng-template carouselSlide [id]="item.id">
            <div class="dynamic-item-wrapper">
              <span class="best-seller-badge">
                {{ rankBy === 'qty' ? (item.qty | number: '1.0-0') + ' ' + ('QTY' | translate) : (item.value | number: '1.0-0') + (element.fields.currencyLabel ? ' ' + element.fields.currencyLabel : '') }}
              </span>
              <ng-container *ngComponentOutlet="item.component; inputs: { data: item.data }"></ng-container>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    }
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title"><span>Content</span></div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12 mb-2">
              <lib-gung-text-input [gungTranslate]="'Title'" [(ngModel)]="element.fields.title"></lib-gung-text-input>
            </div>
            <div class="col-6 mb-2">
              <label>Number of products</label>
              <input class="form-control" type="number" min="1" [(ngModel)]="element.fields.limit" />
            </div>
            <div class="col-6 mb-2">
              <label>Order history, days back</label>
              <input class="form-control" type="number" min="1" [(ngModel)]="element.fields.sinceDays" />
            </div>
            <div class="col-12 mb-2">
              <label>Default sorting</label>
              <select class="form-select" [(ngModel)]="element.fields.defaultRankBy">
                <option value="qty">Quantity sold</option>
                <option value="value">Revenue</option>
              </select>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title"><span>Styles</span></div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12 mt-1 mb-1"><label>Sort toggle</label></div>
            <div class="col-6 mb-2">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input [gungTranslate]="'Active background'" [(ngModel)]="element.fields.toggleActiveBackground"></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.toggleActiveBackground" />
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input [gungTranslate]="'Active text color'" [(ngModel)]="element.fields.toggleActiveColor"></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.toggleActiveColor" />
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input [gungTranslate]="'Inactive background'" [(ngModel)]="element.fields.toggleInactiveBackground"></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.toggleInactiveBackground" />
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input [gungTranslate]="'Inactive text color'" [(ngModel)]="element.fields.toggleInactiveColor"></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.toggleInactiveColor" />
              </div>
            </div>
            <div class="col-6 mb-2">
              <label>Toggle border radius</label>
              <input class="form-control" type="number" min="0" [(ngModel)]="element.fields.toggleBorderRadius" />
            </div>
            <div class="col-12 mt-2">
              <label translate>CAROUSEL_ITEMS</label>
            </div>
            <div class="col-4">
              <lib-gung-number-input [gungTranslate]="'MOBILE'" [(ngModel)]="element.fields.itemsMobile"></lib-gung-number-input>
            </div>
            <div class="col-4">
              <lib-gung-number-input [gungTranslate]="'TABLET'" [(ngModel)]="element.fields.itemsTablet"></lib-gung-number-input>
            </div>
            <div class="col-4">
              <lib-gung-number-input [gungTranslate]="'DESKTOP'" [(ngModel)]="element.fields.itemsDesktop"></lib-gung-number-input>
            </div>
            <div class="col-12 mt-2">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [(ngModel)]="element.fields.autoplay" id="bs-autoplay" />
                <label class="form-check-label" for="bs-autoplay">{{ 'AUTOPLAY' | translate }}</label>
              </div>
            </div>
            @if (element.fields.autoplay) {
              <div class="col-12">
                <lib-gung-number-input
                  [gungTranslate]="'AUTOPLAY_SPEED_SECONDS'"
                  [(ngModel)]="element.fields.autoplaySpeed"
                ></lib-gung-number-input>
              </div>
            }
            <div class="col-12">
              <lib-dynamic-page-element-margin-padding
                [(marginTop)]="element.fields.marginTop"
                [(marginRight)]="element.fields.marginRight"
                [(marginBottom)]="element.fields.marginBottom"
                [(marginLeft)]="element.fields.marginLeft"
                [(paddingTop)]="element.fields.paddingTop"
                [(paddingRight)]="element.fields.paddingRight"
                [(paddingBottom)]="element.fields.paddingBottom"
                [(paddingLeft)]="element.fields.paddingLeft"
              ></lib-dynamic-page-element-margin-padding>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="preview-card-info d-flex align-items-center justify-content-center">
    <i class="fa-solid fa-ranking-star"></i>
  </div>
}
